<script lang="ts">
  export let eyebrowText: string | undefined = '';
  export let title: string | undefined = '';
</script>

<div
  class="flex flex-col justify-start items-center text-center px-4 lg:px-0 max-h-[500px] lg:max-h-full overflow-y-auto"
>
  <p
    class="text-primary-500 text-center text-sm sm:text-md font-semibold w-full lg:max-w-800 break-words"
  >
    {eyebrowText}
  </p>
  <h2
    class="text-gray-900 pt-3 pb-8 sm:pb-12 font-semibold text-[1.875rem] sm:text-display-md w-full lg:max-w-800 break-words"
  >
    {title}
  </h2>
</div>
